import { createFileRoute, Link, redirect } from '@tanstack/react-router'
import { Button } from 'antd'
import React from 'react'
import { PortaledBreadcrumb } from '../components/portaled-breadcrumb'
import { usePagination } from '../hooks/use-pagination'
import { searchQuery } from '../zod/pagination'
import { useTranslation } from 'react-i18next'
import { useUsers } from '../user/hooks'
import { UserTable } from '../user/components/user-table'
import { INDEX_USER } from '../user/permission'
import { useTitle } from '../hooks/use-title'
import { PageTitle } from '../components/page-title'

export const Route = createFileRoute('/_auth/_main/users/')({
    beforeLoad: ({ context }) => {
        if (!context.auth.can(INDEX_USER)) {
            throw redirect({
                to: '/dashboard',
            })
        }
    },
    validateSearch: searchQuery,
    component: Users,
})

function Users() {
    const { t } = useTranslation()
    const search = Route.useSearch()

    const tableProps = usePagination(useUsers, { query: search })
    useTitle(t('Users'))

    const total = tableProps.pagination ? tableProps.pagination.total : undefined

    return (
        <>
            <PortaledBreadcrumb
                items={[
                    {
                        title: t('Users'),
                    },
                ]}
            />
            <PageTitle
                title={t('Users')}
                subtitle={t('Every user on the platform.')}
                count={total}
                countLoading={tableProps.loading === true}
                className="mb-6"
                extra={
                    <Link
                        to="/users/create"
                        className="w-full sm:w-auto"
                    >
                        <Button
                            size="large"
                            type="primary"
                            block
                        >
                            {t('Add {{name}}', { name: t('User') })}
                        </Button>
                    </Link>
                }
            />
            <UserTable {...tableProps} />
        </>
    )
}
